import React from "react";
import { Link } from "react-router-dom";
import "./SubBanner.css";
const SubBanner = () => {
  return (
    <div className="sub-banner flex justify-center items-center">
      <div className=" breadcrumbs text-white text-2xl font-semibold">
        <ul>
          <li >
            <Link to="/" className="hover:no-underline">Home</Link>
          </li>
          <li>
            Services
          </li>
          
        </ul>
      </div>
    </div>
  );
};

export default SubBanner;
